import { render, staticRenderFns } from "./WellnessReport.vue?vue&type=template&id=5b7355d2&scoped=true"
import script from "./WellnessReport.vue?vue&type=script&lang=js"
export * from "./WellnessReport.vue?vue&type=script&lang=js"
import style0 from "./WellnessReport.vue?vue&type=style&index=0&id=5b7355d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7355d2",
  null
  
)

export default component.exports